// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#activeIncident[data-v-7118df46]{background-color:#e9ecef;border-radius:1rem 1rem 1rem 0;padding:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
